import * as ax from "../instrance";
import config from "../../../config/config.js";
var URL = config.apiUrl;

export const getListEduGroup = params => {
  return ax.pJson(URL + "/back/zjjt/getListEduGroup", params);
};
export const getListEduGroupMember = params => {
  return ax.pJson(URL + "/back/zjjt/getListEduGroupMember", params);
};
export const updateEGMToExamine = params => {
  return ax.pJson(URL + "/back/zjjt/updateEGMToExamine", params);
};
export const getListEduGroupNews = params => {
  return ax.pJson(URL + "/back/zjjt/getListEduGroupNews", params);
};
export const getEduGroup = params => {
  return ax.pJson(URL + "/back/zjjt/getEduGroup", params);
};
export const getEduGroupMember = params => {
  return ax.pJson(URL + "/back/zjjt/getEduGroupMember", params);
};
export const getEduGroupNews = params => {
  return ax.pJson(URL + "/back/zjjt/getEduGroupNews", params);
};
export const addEduGroup = params => {
  return ax.pJson(URL + "/back/zjjt/addEduGroup", params);
};
export const addEduGroupNews = params => {
  return ax.pJson(URL + "/back/zjjt/addEduGroupNews", params);
};
export const updateEduGroup = params => {
  return ax.pJson(URL + "/back/zjjt/updateEduGroup", params);
};
export const updateEduGroupNews = params => {
  return ax.pJson(URL + "/back/zjjt/updateEduGroupNews", params);
};
export const updateEduGroupNewsAudit = params => {
  return ax.pJson(URL + "/back/zjjt/updateEduGroupNewsAudit", params);
};
export const updateEduGroupMemberAudit = params => {
  return ax.pJson(URL + "/back/zjjt/updateEduGroupMemberAudit", params);
};
export const getListArticleColumn = params => {
  return ax.pJson(URL + "/cilent/EduGroup/getListArticleColumn", params);
};




// WEBPACK FOOTER //
// ./src/api/eduGroupApi/eduGroupAx.js